import { sendRequest } from '../../config';

export interface createTreatmentParams {
    /** parametros obligatorios */
    cpais: string;
    cusuario: string;
    ccategoria: string;    
    itipo: string;
    nlocaliza: string;
    cdiagnos: string;
    ctrata: string;
    ndiente: string;
    ncantrep: string;
    ibaremo: string;
    iorigen: string;
    pDataBaremo: {
        cciaseg: string;
        ccliente: string;
        cplan: string;
        cfecha: string;
        fcontacto: string;
        tlocaliza: string;
        cpais: string;
        cdoctor: string;
        cclinica: string;
        itclave: string;
    };

    /** parametros opcionales */
    xnclave?: string;
}

export const crearLote = async (params: createTreatmentParams): Promise<unknown> => {
    const ENDPOINT = 'wslotes/crearLote';
    return sendRequest({
        method: 'post',
        path: ENDPOINT,
        body: params,
    });
};